import {HeaderButtons} from '../common/header-buttons/header-buttons';
import {HeaderButtonEnum} from '../common/header-buttons/header-buttons-hook';

import * as styles from './simple-header.scss';

export function SimpleHeader(): JSX.Element {
    return <HeaderButtons buttons={[HeaderButtonEnum.Language]} className={styles.SimpleHeader} />;
}
